import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { theme } from 'antd'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import bloodTestIcon from '../../../../../assets/icons/blood-test.png'
import cardiogramIcon from '../../../../../assets/icons/cardiogram.png'
import healthCheckIcon from '../../../../../assets/icons/health-check.png'
import medicalCheckIcon from '../../../../../assets/icons/medical-check.png'
import medicationIcon from '../../../../../assets/icons/medical.png'
import restaurantIcon from '../../../../../assets/icons/restaurant.png'
import CoreEnums from '../../../../../core/utils/enums'
import coreReducer from '../../../../../core/utils/reducer'
import MacroTrackerWrapper from '../../../AI Tools/Meal Tracker'
import PatAppointments from '../../../Appointments'
import PatCareSync from '../../../CareSync'
import MobHealthStatsWrapper from '../../../Health Stats/Mobile/Components/MobHealthStatsWrapper'
import PatMedHist from '../../../Medical History'
import PatMedications from '../../../Medications'
import RedirectMobileApp from './redirectMobileApp'

import '../styling/MobileQuickButtons.css'

// Create a mobile wrapper component\

const MobQuickButtons = ({ onButtonClick }) => {
  const authState = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  const handleQuickNavigate = (key, label) => {
    let component = <></>
    switch (key) {
      case CoreEnums.tabKeys.PAT_MACRO_TRACKER:
        component = <RedirectMobileApp feature='meal_tracker' />
        break
      case CoreEnums.tabKeys.MEDICAL_HISTORY:
        component = <PatMedHist />
        break
      case CoreEnums.tabKeys.PAT_APPOINTMENTS:
        component = <PatAppointments />
        break
      case CoreEnums.tabKeys.PAT_HEALTH_STATS:
        component = <MobHealthStatsWrapper />
        break
      case CoreEnums.tabKeys.PAT_CARE_SYNC:
        component = <PatCareSync />
        break
      case CoreEnums.tabKeys.PAT_MEDICATIONS:
        component = <RedirectMobileApp feature='medications' />
        break

      // case CoreEnums.tabKeys.PAT_CARE_SYNC_PROD:
      //   component = <MobPatCareSyncWrapper />
      //   break
    }
    dispatch(
      coreReducer.actions.addTab({
        key: key,
        closable: true,
        label: label,
        children: component // Use the wrapper
      })
    )
  }
  const buttons = [
    {
      icon: healthCheckIcon,
      label: CoreEnums.tabTitles.MEDICAL_HISTORY,
      key: CoreEnums.tabKeys.MEDICAL_HISTORY,
      isCustomIcon: true
    },
    {
      icon: cardiogramIcon,
      label: 'Health Metrics',
      key: CoreEnums.tabKeys.PAT_HEALTH_STATS,
      isCustomIcon: true
    },
    {
      icon: medicationIcon,
      label: 'Medications',
      key: CoreEnums.tabKeys.PAT_MEDICATIONS,
      isCustomIcon: true
    },
    // {
    //   icon: bloodTestIcon,
    //   label: CoreEnums.tabTitles.PAT_CARE_SYNC,
    //   key: CoreEnums.tabKeys.PAT_CARE_SYNC,
    //   isCustomIcon: true
    // },
    {
      icon: medicalCheckIcon,
      label: CoreEnums.tabTitles.PAT_APPOINTMENTS,
      key: CoreEnums.tabKeys.PAT_APPOINTMENTS,
      isCustomIcon: true
    },
    {
      icon: restaurantIcon,
      label: 'Meal Tracker',
      key: CoreEnums.tabKeys.PAT_MACRO_TRACKER,
      isCustomIcon: true
    }
    // {
    //   icon: faUserDoctor,
    //   label: CoreEnums.tabTitles.PAT_CARE_SYNC_PROD,
    //   key: CoreEnums.tabKeys.PAT_CARE_SYNC_PROD
    // }
  ]
  const { token } = theme.useToken()
  return (
    <div className='quick-buttons-container'>
      <div style={{ display: 'flex', padding: '8px 16px', gap: '16px', minWidth: 'max-content' }}>
        {buttons.map((button, index) => (
          <div
            key={index}
            className='quick-button-card'
            style={{
              width: 85,
              height: 85,
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              flexShrink: 0
            }}
            onClick={() => {
              handleQuickNavigate(button.key, button.label)
            }}
          >
            <div className='icon-container'>
              {button.isCustomIcon ? (
                <img src={button.icon} alt={button.label} style={{ width: 28, height: 28 }} />
              ) : (
                <FontAwesomeIcon style={{ fontSize: 20, color: token.colorPrimary }} icon={button.icon} />
              )}
            </div>
            <div style={{ fontSize: 9 }}>{button.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default MobQuickButtons
